import { HttpParameterCodec, HttpUrlEncodingCodec } from '@angular/common/http';

export class HttpParamsEncoder implements HttpParameterCodec, HttpUrlEncodingCodec {
  public encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  public encodeValue(value: string): string {
    // debugger;
    return encodeURIComponent(value);
  }
  public decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  public decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
